# src/components/BrandModelSelector.vue
<template>
    <div class="brand-model-selector">
        <el-select v-model="selectValue" ref="brandSelect" clearable placeholder="请选择品牌" class="brand-select"
            @clear="handleClear" remote filterable :filter-method="handleSearch">
            <el-option class="brand-option" style="height: 240px;display: flex;" :value="modelValue">
                <div class="brandList scrollBar-custom">
                    <div class="brandItem " :class="{ active: selectedBrandId == item.id }" v-for="item in brandList"
                        :key="item.id" @click.stop="handleBrandChange(item)">
                        <span>{{ item.brandName }}</span>
                    </div>
                </div>
                <div class="brandList scrollBar-custom" v-if="modelList.length > 0">
                    <div class="brandItem" :class="{ active: selectedModelId == item.id }" v-for="item in modelList"
                        :key="item.id" @click.stop="handleModelChange(item)">
                        <span>{{ item.modelName }}</span>
                    </div>
                </div>
                <div class="brandList scrollBar-custom" v-else>
                    <div class="tips" style="text-align: center;line-height: 240px;">暂无数据</div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    name: 'BrandModelSelector',
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            allBrandList: [],
            brandList: [],
            modelList: [],
            selectedBrand: {},
            selectedModel: {},
            selectedBrandId: '',
            selectedModelId: '',
            selectValue: '',
            searching: false
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newVal) {
                this.selectValue = newVal;
                if (!newVal) {
                    this.handleClear();
                }
            }
        }
    },
    created() {
        this.getBrand();
    },

    methods: {
        // 获取品牌
        async getBrand() {
            let url = "/api/v1/common/car/brands";
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.allBrandList = data.allBrands;
                this.brandList = data.allBrands;
            }
        },
        handleBrandChange(item) {
            this.selectedBrand = item
            this.selectedBrandId = item.id
            if (this.searching) {
                this.modelList = item.children;
            }else {
                this.getModel(item.id);
            }
        },
        // 获取车型
        async getModel(brandId) {
            let url = `/api/v1/common/car/models/${brandId}`;
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.modelList = data;
            }
        },
        handleClear() {
            this.selectedBrand = {};
            this.selectedModel = {};
            this.selectedBrandId = '';
            this.selectedModelId = '';
            this.modelList = [];
            this.$emit('update:modelValue', '');
            this.$emit('modelChange', [this.selectedBrand, this.selectedModel]);
        },
        async handleSearch(keyword) {
            if (!keyword) {
                this.searching = false;
                this.getBrand();
                return;
            }
            this.searching = true;
            let url = "/api/v1/common/car/models/search";
            let { code, data } = await this.$axios.get(url, {
                modelName: keyword
            });
            if (code === 1 && data) {
                const groupByBrand = data.reduce((acc, item) => {
                    if (!acc[item.brandId]) {
                        acc[item.brandId] = [];
                    }
                    acc[item.brandId].push(item);
                    return acc;
                }, {});

                this.brandList = Object.entries(groupByBrand).map(([brandId, models]) => {
                    const brand = this.allBrandList.find(b => b.id === Number(brandId));
                    return {
                        id: brandId,
                        brandName: brand ? brand.brandName : '未知品牌',
                        children: models
                    };
                });
                this.modelList = this.brandList[0].children;
            }
        },
        handleModelChange(item) {
            this.selectedModel = item
            this.selectedModelId = item.id
            // const value = this.selectedBrand.brandName + ' ' + this.selectedModel.modelName
            const value = this.selectedModel.modelName
            this.selectValue = value
            this.$emit('update:modelValue', value)
            this.$emit('modelChange', [this.selectedBrand, this.selectedModel])
            this.$refs.brandSelect.blur()
        }
    }
}
</script>

<style lang="less" scoped>
.brandList {
    flex: 1;
    height: 240px;
    overflow-y: auto;

    .brandItem {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;

        &:hover {
            background-color: #F0F0F0;
            color: #409Eff;
        }
    }

    .active {
        background-color: #F0F0F0;
        color: #409Eff;
    }

}

.el-select-dropdown__item.selected {
    background-color: white !important;
    color: #333 !important;

    &:hover {
        background-color: white !important;
        color: #333 !important;
    }
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: white !important;
    color: #333 !important;
}

.el-select-dropdown__item {
    padding: 0;
}

::v-deep .el-select-dropdown__empty {
    background-color: #f00 !important;
}

.el-select-dropdown {
    background-color: #f00 !important;
}
</style>